/**
 * Spec 044 · cuántas reservas vigentes hay en lo pintado.
 */
import { contarEnVentana, type RelojPared } from '../lib/citas-vigentes'
import type { Columna } from './calendario-rejilla'

export function vigentesPorProfesional(
    profesionales: readonly { id: number }[],
    citas: readonly { profesionalId: number | null; dia: string; inicio: string }[],
    reloj: RelojPared,
    incluirPasadas = false,
): Map<number, number> {
    return new Map(
        profesionales.map((p) => [
            p.id,
            contarEnVentana(
                citas.filter((c) => c.profesionalId === p.id),
                reloj,
                incluirPasadas,
            ),
        ]),
    )
}

export function columnasConVigentes(
    columnas: Columna[],
    reloj: RelojPared,
    diaPagina: string,
    incluirPasadas = false,
): Columna[] {
    return columnas.map((col) => ({
        ...col,
        vigentes: contarEnVentana(
            col.citas.map((c) => ({ dia: col.dia ?? diaPagina, inicio: c.inicio })),
            reloj,
            incluirPasadas,
        ),
    }))
}
